import { Button } from '../../../../components/ui/Button'
import React, { useState } from 'react'

interface ReasonSelectionProps {
  onCancel?: () => void
  onConfirm?: (reason: string, customReason?: string) => void
}

const ReasonSelection: React.FC<ReasonSelectionProps> = ({
  onCancel,
  onConfirm,
}) => {
  const [selectedReason, setSelectedReason] = useState<string>('')
  const [customReason, setCustomReason] = useState<string>('')

  const reasons = [
    'El precio es alto',
    'Las condiciones no se ajustan a lo que necesito',
    'Encontré otra opción más conveniente',
    'Decidí no avanzar con el proyecto',
    'Tiempo de entrega / disponibilidad',
    'Otros (especificar)',
  ]

  const handleSubmit = () => {
    if (selectedReason) {
      onConfirm?.(
        selectedReason,
        selectedReason === 'Otros (especificar)' ? customReason : undefined
      )
    }
  }

  return (
    <div className="flex justify-center items-center w-full">
      <div className="rounded-xl p-10 max-w-lg w-full ">
        <h2 className="text-2xl font-semibold text-center mb-3 text-gray-800">
          Queremos conocerte mejor
        </h2>
        <p className="text-center text-gray-600 mb-8 leading-relaxed">
          Tu opinión nos ayuda a mejorar y ofrecerte mejores propuestas.
        </p>

        <div className="mb-8">
          <h3 className="text-base font-medium mb-5 text-gray-800">
            ¿Por qué rechazaste la cotización?
          </h3>

          <div className="space-y-3">
            {reasons.map((reason, index) => (
              <label
                key={index}
                className="flex items-center cursor-pointer py-2"
              >
                <input
                  type="radio"
                  name="rejection-reason"
                  value={reason}
                  checked={selectedReason === reason}
                  onChange={e => setSelectedReason(e.target.value)}
                  className="sr-only"
                />
                <div
                  className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center transition-colors ${
                    selectedReason === reason
                      ? 'border-blue-500'
                      : 'border-gray-300'
                  }`}
                >
                  {selectedReason === reason && (
                    <div className="w-2.5 h-2.5 rounded-full bg-blue-500"></div>
                  )}
                </div>
                <span className="text-sm text-gray-700 leading-snug">
                  {reason}
                </span>
              </label>
            ))}
          </div>

          {selectedReason === 'Otros (especificar)' && (
            <textarea
              className="w-full mt-3 p-3 border-2 border-gray-200 rounded-lg resize-y text-sm font-sans transition-colors focus:outline-none focus:border-blue-500 placeholder-gray-400"
              placeholder="Escribe aquí"
              value={customReason}
              onChange={e => setCustomReason(e.target.value)}
              rows={3}
            />
          )}
        </div>

        <div className="flex gap-3">
          <Button
            variant="outline"
            size="default"
            onClick={onCancel}
            className="px-8 py-3 text-blue-500 border-blue-500 hover:bg-blue-50"
          >
            Regresar
          </Button>

          <Button
            size="default"
            onClick={handleSubmit}
            className="px-8 py-3 bg-blue-500 hover:bg-blue-600 text-white"
          >
            Confirmar y continuar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ReasonSelection
